import { getIsDaylightSavings, ONE_HOUR_OF_MS } from "utils/timeUtils";
import { useFormatZoned } from "utils/customHooks/genericHooks";

/**
 * Get epoch time as date with day string
 * Bases display based on whether given epoch is in DST or not
 *
 * @export
 * @param {number} epoch
 * @return {*}
 */

export function useEpochAsDateString(epoch: number, format: string) {
  const formatZoned = useFormatZoned();

  const isCurrentlyDST = getIsDaylightSavings();
  const isEpochDST = getIsDaylightSavings(new Date(epoch));

  const shiftedEpochTime =
    // Accessed in DST, epoch is not DST
    isCurrentlyDST && !isEpochDST
      ? epoch + ONE_HOUR_OF_MS
      : // Accessed outside of DST, epoch is in DST
        !isCurrentlyDST && isEpochDST
        ? epoch - ONE_HOUR_OF_MS
        : epoch;

  return formatZoned(shiftedEpochTime, format);
}
